import { AiFillPlusCircle, AiOutlineLoading } from "react-icons/ai";
import { BiSolidEditAlt } from "react-icons/bi";
import { useRef, useState, useEffect } from "react";

const UploadImage = ({ imageUrl, setImageUrl, onImageUpload }) => {
  const fileInputRef = useRef();
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const beforeUpload = (file, maxFileSize = 2) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setImageError(true);
      return false;
    }

    const isLt2M = file.size / 1024 / 1024 < maxFileSize;
    if (!isLt2M) {
      setImageError(true);
      return false;
    }

    return true;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && beforeUpload(file)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUrl(reader.result);
        setImageLoading(false);
      };
      setImageLoading(true);
      reader.readAsDataURL(file);

      onImageUpload(file); // for upload to server or parent component
    }
  };

  useEffect(() => {
    if (imageError) {
      setImageLoading(false);
    }
  }, [imageError]);

  return (
    <div className="relative w-[120px] mb-3">
      <h2>Click to upload</h2>
      <div
        onClick={() => fileInputRef.current.click()}
        className="cursor-pointer w-[120px] h-[120px] border-2 border-white bg-no-repeat bg-gray-300 bg-cover bg-center flex items-center justify-center text-primary"
        style={{
          backgroundImage: `url('${imageUrl || "/images/dummy.jpeg"}')`,
        }}
      >
        {imageLoading && (
          <AiOutlineLoading className="inline animate-spin text-3xl" />
        )}
      </div>
      <button
        onClick={() => fileInputRef.current.click()}
        className="absolute w-[40px] h-[40px] border-2 border-white rounded-full bg-primary bottom-0 right-0 md:-right-2 flex items-center justify-center text-white text-[20px]"
      >
        {imageUrl ? (
          <BiSolidEditAlt className="text-black" />
        ) : (
          <AiFillPlusCircle className="text-black" />
        )}
      </button>
      <input
        type="file"
        accept="image/jpeg,image/png"
        onChange={handleFileChange}
        ref={fileInputRef}
        className="hidden"
      />
    </div>
  );
};

export default UploadImage;
